import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="policy-content">
              <h3>Digital Service Delivery</h3>
              <p>Since IBRLIVE provides digital API services, there is no physical shipping involved. However, we have clear policies regarding service delivery and availability.</p>
              
              <div className="row pt-4">
                <div className="col-lg-6">
                  <div className="info-card">
                    <h4>Service Delivery</h4>
                    <ul>
                      <li>API access is provided immediately upon successful subscription</li>
                      <li>API keys are delivered via email within 5 minutes of payment confirmation</li>
                      <li>Documentation and integration guides are available instantly</li>
                      <li>Support tickets are responded to within 24 hours</li>
                    </ul>
                  </div>
                </div>
                
                <div className="col-lg-6">
                  <div className="info-card">
                    <h4>Service Availability</h4>
                    <ul>
                      <li>99.9% uptime guarantee</li>
                      <li>24/7 monitoring and maintenance</li>
                      <li>Planned maintenance windows are announced 48 hours in advance</li>
                      <li>Emergency maintenance is communicated immediately</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="row pt-4">
                <div className="col-lg-12">
                  <div className="info-card">
                    <h4>Geographic Availability</h4>
                    <p>Our services are available globally, with data centers in multiple regions to ensure optimal performance worldwide.</p>
                    
                    <div className="delivery-timeline">
                      <h5>Delivery Timeline</h5>
                      <div className="timeline">
                        <div className="timeline-item">
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <h6>Immediate Access</h6>
                            <p>API access granted instantly upon subscription</p>
                          </div>
                        </div>
                        <div className="timeline-item">
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <h6>API Keys Delivery</h6>
                            <p>Email delivery within 5 minutes of payment</p>
                          </div>
                        </div>
                        <div className="timeline-item">
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <h6>Documentation Access</h6>
                            <p>Complete guides available instantly</p>
                          </div>
                        </div>
                        <div className="timeline-item">
                          <div className="timeline-marker"></div>
                          <div className="timeline-content">
                            <h6>Support Response</h6>
                            <p>24-hour response time for all queries</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .policy-page {
          padding: 80px 0 0 0;
          min-height: 80vh;
          background: #f8f9fa;
        }
        
        .policy-content {
          background: white;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          margin-bottom: 30px;
        }
        
        .policy-content h3 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #333;
          margin: 0 0 20px 0;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        
        .policy-content p {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 30px;
        }
        
        .info-card {
          background: #f8f9fa;
          padding: 25px;
          border-radius: 10px;
          margin-bottom: 20px;
          height: 100%;
          border-left: 4px solid #007bff;
        }
        
        .info-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #333;
          margin: 0 0 15px 0;
        }
        
        .info-card ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .info-card li {
          font-size: 0.9rem;
          line-height: 1.6;
          color: #555;
          margin-bottom: 8px;
          padding: 5px 0;
          border-bottom: 1px solid #e9ecef;
        }
        
        .info-card li:last-child {
          border-bottom: none;
        }
        
        .info-card li:before {
          content: "✓";
          color: #007bff;
          font-weight: bold;
          margin-right: 10px;
        }
        
        .delivery-timeline {
          margin-top: 30px;
        }
        
        .delivery-timeline h5 {
          font-size: 1.2rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
        }
        
        .timeline {
          position: relative;
          padding-left: 30px;
        }
        
        .timeline:before {
          content: "";
          position: absolute;
          left: 15px;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #007bff;
        }
        
        .timeline-item {
          position: relative;
          margin-bottom: 25px;
        }
        
        .timeline-marker {
          position: absolute;
          left: -22px;
          top: 5px;
          width: 12px;
          height: 12px;
          background: #007bff;
          border-radius: 50%;
          border: 3px solid white;
          box-shadow: 0 0 0 3px #007bff;
        }
        
        .timeline-content h6 {
          font-size: 1rem;
          font-weight: 600;
          color: #333;
          margin: 0 0 5px 0;
        }
        
        .timeline-content p {
          font-size: 0.9rem;
          color: #666;
          margin: 0;
        }
        
        @media (max-width: 768px) {
          .policy-page {
            padding: 40px 0 0 0;
          }
          
          .policy-content {
            padding: 20px;
          }
          
          .info-card {
            padding: 20px;
            margin-bottom: 15px;
          }
          
          .timeline {
            padding-left: 25px;
          }
          
          .timeline:before {
            left: 10px;
          }
          
          .timeline-marker {
            left: -17px;
            width: 10px;
            height: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default ShippingPolicy;
